// extracted by mini-css-extract-plugin
export var labelWrapper = "_lw-0";